import { useEffect, useSyncExternalStore } from 'react';

import {
  assinarCadastroLogado,
  buscarCadastroLogado,
  lerCadastroCacheado,
} from 'hooks/usePerfilProfissional';

export { definirAvatarUsuario } from 'hooks/usePerfilProfissional';

/**
 * A foto de perfil do usuário logado — o nome do arquivo, ou null sem foto (e enquanto não sabe).
 *
 * Lê do mesmo cache de GET /usuario/{id} que o usePerfilProfissional alimenta, então no NavBar,
 * que já usa aquele hook, isto não custa requisição nenhuma. `useSyncExternalStore` em vez de
 * estado local: quando o Meu cadastro chama `definirAvatarUsuario`, todo mundo que está montado
 * (menu desktop, menu sanduíche, barra inferior do app) re-renderiza com o nome novo, sem prop
 * drilling e sem refetch.
 */
export function useAvatarUsuario(userId) {
  const avatar = useSyncExternalStore(
    assinarCadastroLogado,
    () => (userId ? lerCadastroCacheado(userId)?.usuario?.avatar ?? null : null),
  );

  useEffect(() => {
    if (!userId || lerCadastroCacheado(userId)) return;
    buscarCadastroLogado(userId).catch(() => { /* silencioso: sem cadastro, ficam as iniciais */ });
  }, [userId]);

  return avatar;
}
